import { UserRole } from "../../store/types/context";
import UserPartners from "./Users";

export const path = "/users";
export const component = UserPartners;
export const roles = [UserRole.Admin]
